<template>
	<div>
		<div class="xinz">
			<!--<div class="right">-->
			<!--&lt;!&ndash;<el-button type="warning" @click="bankAdd" v-if="canAdd"><i class="fa fa-plus" /> {{$t('m.newBank')}}</el-button>&ndash;&gt;-->
			<!--<el-button type="warning" @click="customerAdd" ><i class="fa fa-plus" /> 新增客戶資訊</el-button>-->
			<!--</div>-->

		</div>
		<div>

			<div class="ind_main ">
				<div class="fl" style="margin-bottom: 10px;" v-if="$store.getters.searchSte"><button class="fanhui" @click = retSearch> 返回</button></div>
				
				<div class="fl" style="margin-bottom: 10px;" v-if="$store.getters.searchSte == false">
					<button class="fanhui" @click = "serac" v-if="!$store.getters.ismobilePhone"> 返回</button>
					<div class="banckFont" @click = "serac" v-if="$store.getters.ismobilePhone">客戶詳情</div>
					</div>
					<div class="kehu_list kehu_list2 kehu_list3">
						<ul>
							<li>
								<!--<el-collapse accordion>-->
								<!--<el-collapse-item :title="customer.code">-->
									<table cellpadding="0" cellspacing="0">

										<tr @click="isonIn">
												<td colspan="4" class="b_1" >
													<div :class="$store.getters.ismobilePhone==false?'search_1':'search_2'">{{customer.code}}</div>
													<!-- <span :class="$store.getters.ismobilePhone==false?'search_1':'search_2'">{{customer.code}}</span> --><span style="position: absolute;  right:40px;color:#f00;top:-6px;">
												<template v-if="isShow == true">
													<img  src="../assets/f1.png"/>
												</template>
												<template v-if="isShow == false">
													<img src="../assets/f2.png"/>
												</template>
												</span></td>
										</tr>
										<tr v-if="isShow">
											<td width="20%" align="right" class="w0">姓名：</td>
											<td>{{customer.name}}</td>
											<td width="20%" align="right" class="w0"></td><!--客戶編號：-->
											<td></td>
										</tr>
										<tr v-if="isShow">
											<td  width="20%" align="right" class="w0">電話：</td>
											<td>{{customer.phone}}</td>
											<td width="150px" align="left" style="font-size: 12.5px;">銷售員：</td>
											<td align="left">{{customer.sales}}</td>
										</tr>
										<tr v-if="isShow" >
											<td width="20%" valign="top" align="right" class="w0">地址：</td>
											<td colspan="3" valign="top"> {{customer.address}}</td>
										</tr>
									</table>
								<!--<tem-->
								<!--</el-collapse-item>-->
								<!--</el-collapse>-->
							</li>
						</ul>
					</div>



				<div class="sch_btn" v-if="!$store.getters.ismobilePhone">

					<div class="sbtn fl">
						<el-button  v-bind:class="{qbkc:isQbkc}" @click="swcListTwo" > 全部庫存</el-button>
						<el-button  v-bind:class="{qbkc:isRhdcx}" @click="swcListThree" > 入貨單查詢</el-button>
						<el-button v-bind:class="{qbkc:isChdcx}" @click="swcListFour" > 出倉單查詢</el-button>
					</div>
					<div class="sbtn fr" v-if="sbtnfr">
						
						 <el-button v-bind:class="{qbkc:isQhlb}" @click="swcList"><span style="font-size: 16px;"> {{listText}}</span></el-button> 
					</div> 

				</div>
				<div id="btnlist" v-if="$store.getters.ismobilePhone">
					<ul>
					    <li :class="selectid==0?'selectbtn':'noselectbtn'" @click="swcListTwo">全部庫存</li>
					    <li :class="selectid==1?'selectbtn':'noselectbtn'" @click="swcListThree">入貨單查詢</li>    
					    <li :class="selectid==2?'selectbtn':'noselectbtn'" @click="swcListFour">出倉單查詢</li>
					    <!-- <li :class="selectid==3?'selectbtn':'noselectbtn'" @click="swcList">{{listText}}</li> -->
					  </ul>
				</div>
				<div>
					<!-- >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>清單顯示<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< -->
					<div class="ruku_list" style="margin-top: 80px" v-if="ruku_list" >
						<!-- 电脑 -->
						<table cellspacing="0" cellpadding="0" class="responsive" style="width:100%;" v-if="$store.getters.ismobilePhone == false">
							<thead>
							<tr class="trHead">
								<th>樓層</th>
								<th>貨架</th>
								<th>單位</th>
								<th>物品</th>
								<th>單號</th>
								<th>入倉日期</th>
								<!--<th width="50%">存货</th>-->
								<!--<th>排序</th>-->
							</tr>
							</thead>
							<tr v-if="locationPageList.length != 0" v-for="item1 in locationPageList" >
								<td class="name">
									<template v-if="item1.floor == 0">
										G/F
									</template>
									<template v-else="item1.floor != 0">
										{{item1.floor}}/F
									</template>
								</td>
								<td class="number" >
									{{item1.name}}
								</td>
								<td class="actions">
									{{item1.companyNo}}
								</td>
								<td class="actions" style="text-align: left">
									{{item1.stock}}
								</td>
								<td class="actions">
									{{item1.code}}
								</td>
								<td class="actions">
									{{item1.createDate}}
								</td>


								<!--<td class="actions">-->
								<!--{{item1.order}}-->
								<!--</td>-->
							</tr>
							<tr  v-if="locationPageList.length == 0">
								<td colspan="6">暫無數據</td>
							</tr>

						</table>
						</div>
						<div  style="margin-top: -90px;"  v-if="$store.getters.ismobilePhone&&ruku_list">
						<!-- 手机 -->
						<table  cellspacing="0" cellpadding="0" class="responsive" >
							<thead>
							<tr class="trHead">
								<th>單位</th>
								<th>位置</th>
								<th>物品</th>
								<th>單號</th>

								<!--<th>樓層</th>-->
								<!--<th>貨架</th>-->
								<!--<th>單位</th>-->
								<!--<th>物品</th>-->
								<!--<th>單號</th>-->
								<!--<th>入倉日期</th>-->
								<!--<th width="50%">存货</th>-->
								<!--<th>排序</th>-->
							</tr>
							</thead>
							<tr v-if="locationPageList.length != 0" v-for="item1 in locationPageList" >
								<td class="actions">
									{{item1.companyNo}}
								</td>
								<td class="name">
									<template v-if="item1.floor == 0">
										GF {{item1.name}}
									</template>
									<template v-else="item1.floor != 0">
										{{item1.floor}}F {{item1.name}}
									</template>
								</td>
								<td class="number" >
									{{item1.stock}}
								</td>
								<td class="actions">
									{{item1.code}}
								</td>
							</tr>
							<tr  v-if="locationPageList.length == 0">
								<td colspan="6">暫無數據</td>
							</tr>

						</table>
					</div>


					<!-- >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> 全部庫存 <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< -->
					<div v-if="loadingimg" style="position: absolute;left: 50%;top: 34%;"><img src="../assets/loding.gif" /></div>
					<div class="ind_main" v-if="ind_main" >
						<div class="ind_cont" >
							<div class="tabs" style="margin-top: 1%">
								<div class="tab-item" v-for="flo in locationList" v-bind:class="{'activeone':flo.floor == num}" :id="'tab'+flo.floor">
									<!--左邊4個-->
									<table cellpadding="0" cellspacing="0" class="tab1">
										<tr v-for="n in 4" class="xuline" style="width:25%; float:left;">
											<template v-for="y in flo.maxY"  class="xuline" style="width:25%; float:left;">
												<template v-if="flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta)">
													<td v-bind:class="{'searchcur':flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor).status == 1}"
														@click="locationEdit(flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor).id)">
														{{flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor).name}}
														<img src="../../static/img/redHomeIcon.png"></img>
														</td>
												</template>
												<template v-else-if="$store.getters.sta">
													<td> </td>
												</template>
												<template v-if="flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false)">
													<template v-if="flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false).status == 1">
														<td class="searchcur" @click="cusInventory(flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false).id)">{{flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false).name}}
														<img src="../../static/img/redHomeIcon.png"></img> 
														</td>
													</template>
													<template v-if="flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false).status != 1">
														<td>{{flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false).name}}</td>
													</template>
												</template>
												<template v-else-if="$store.getters.sta==false">
													<td> </td>
												</template>
											</template>
										</tr>
									</table>

									<!--中間八個-->
									<table cellpadding="0" cellspacing="0" class="tab2">
										<tr v-for="n in 10" v-if="n>4" class="xuline" style="width:16.6%; float:left;">
											<template v-for="y in flo.maxY"  class="xuline" style="width:25%; float:left;">
												<template v-if="flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta)">
													<td v-bind:class="{'searchcur':flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor).status == 1}"
														@click="locationEdit(flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor).id)">
														{{flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor).name}}
														 <img src="../../static/img/redHomeIcon.png"></img>
														</td>
												</template>
												<template v-else-if="$store.getters.sta">
													<td> </td>
												</template>
												<template v-if="flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false)">
													<template v-if="flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false).status == 1">
														<td class="searchcur" @click="cusInventory(flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false).id)">{{flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false).name}}
														 <img src="../../static/img/redHomeIcon.png"></img>
														</td>
													
													</template>
													<template v-if="flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false).status != 1">
														<td>{{flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false).name}}</td>
													</template>
												</template>
												<template v-else-if="$store.getters.sta==false">
													<td> </td>
												</template>
											</template>
										</tr>
									</table>

									<!--右邊4個-->
									<table cellpadding="0" cellspacing="0" class="tab3">
										<tr v-for="n in 16" v-if="n>10" class="xuline" style="width:16.6%; float:left;">
											<template v-for="y in flo.maxY" class="xuline" style="width:25%; float:left;">
												<template v-if="flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta)">
													<td v-bind:class="{'searchcur':flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor).status == 1}"
														@click="locationEdit(flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor).id)">
														{{flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor).name}}
														<img src="../../static/img/redHomeIcon.png"></img>
														</td>
												</template>
												<template v-else-if="$store.getters.sta">
													<td> </td>
												</template>
												<template v-if="flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false)">
													<template v-if="flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false).status == 1">
														<td class="searchcur" @click="cusInventory(flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false).id)">{{flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false).name}}
														<img  src="../../static/img/redHomeIcon.png"></img>
														</td>
													</template>
													<template v-if="flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false).status != 1">
														<td>{{flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false).name}}</td>
													</template>
												</template>
												<template v-else-if="$store.getters.sta==false">
													<td> </td>
												</template>

											</template>

										</tr>
									</table>
									<!-- <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<电脑>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> -->
									<div class="tongji" v-if="$store.getters.ismobilePhone == false">
										<div v-for="floside in floSideCount" v-if="flo.floor == floside.floor" :class="'fl_'+floside.side"><span class="red">{{floside.usecount}}</span>/{{floside.flosidecount}}</div>
										<!--<div class="fl_1"><span class="red">{{flo.aInfoa}}</span>/{{flo.aInfob}}</div>-->
										<!--<div class="fl_2"><span class="red">{{flo.bInfoa}}</span>/{{flo.bInfob}}</div>-->
										<!--<div class="fl_3"><span class="red">{{flo.cInfoa}}</span>/{{flo.cInfob}}</div>-->
									</div>

								</div>
							</div>

							<!-- 电脑 -->
							<div class="table_qh" id="table_qh" v-if="$store.getters.ismobilePhone == false">
								<ul  >
									<template v-for="(flo,index) in locationList">
										<li  :class="{'background cur':changeRed == index}" :id="'tabBtn'+flo.floor"  @click="listCut(flo.floor)" v-if="flo.floor == 0" >G/F</li>
										<li  :class="{'background cur':changeRed == index}" :id="'tabBtn'+flo.floor"  @click="listCut(flo.floor)" v-else="flo.floor != 0" >{{flo.floor}}/F</li>

									</template>
								</ul>
							</div>


							<!-- 手机 -->
							<div class="mob_tongji" v-for="(flo,index) in locationList" v-if="$store.getters.ismobilePhone">
								<!--<div class="fr" v-if="index ==0">總樓層共<span class="bule">{{flo.loccount}}</span>個</div>-->
								<div class="fl">當前樓層共<span class="red">{{flo.floorcount}}</span>個位置</div>
								<div class="mob_tjTxt">
									<div class="fl_0" v-if="flo.floor == 0">G/F</div>
									<div class="fl_0" v-else="flo.floor == 0">{{flo.floor}}/F</div>
									<div v-for="floside in floSideCount" v-if="flo.floor == floside.floor" :class="'fl_'+floside.side"><span class="red">{{floside.usecount}}</span>/{{floside.flosidecount}}</div>

								</div>

							</div>

						</div>
					</div>

					<!-- >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> 入貨單詳情/出貨單詳情 <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< -->
					<div class="ruku_list" v-if="ruku_listTwo">
						<el-form v-if="addWarehousingList != 0">
							<table cellspacing="0" cellpadding="0" class="responsive" >
								<template v-for="(items,i) in addWarehousingList">
									<thead>
									<tr >
										<th colspan="3" style="text-align: left">
											{{items.createDate | date('%Y-%m-%d %H:%M')}}
											<!--<el-date-picker v-model="items.createDate" format="yyyy年MM月dd日 HH:mm" :disabled="items.createDateShow"-->
											<!--type="datetime" style="width: 25%" size="large">-->
											<!--</el-date-picker>-->
										</th>
										<th ><span>Job00{{i+1}}</span></th>
									</tr>
									<tr class="trHead">
										<th >單位</th>
										<th >位置</th>
										<th >物品</th>
										<th >數量</th>
									</tr>
									</thead>
									<tr v-for="(item1,index) in items.storInItem" >
										<td class="number" >
											<span>{{item1.unit}}{{item1.boxNo}}</span>
										</td>
										<td class="actions">
											<span>{{item1.value}}</span>
											<template v-if="item1.state == 1">
												（已出倉）
											</template>

										</td>
										<td class="name " style="text-align: left;" >
											<span >{{item1.item}}</span>
										</td>
										<td class="actions">
											<span>{{item1.qty}}</span>
										</td>
									</tr>
								</template>
							</table>
						</el-form>
						<el-form v-if="addWarehousingList == 0">
							<table cellspacing="0" cellpadding="0" class="responsive">
								<td>暫無數據</td>
							</table>

						</el-form>
					</div>



					<!-- >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> 入貨列表/出貨列表 <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< -->
					<div v-if="show">
						<div class="ind_main ind_main2">
							<div class="ind_cont2 ">
								<div id="app" >


										<!-- 手机 -->
										<template v-if="$store.getters.ismobilePhone">
											<el-table :header-cell-style="{background:'#4B78FF',color:'#FFFFFF'}"  border style="width: 100%;margin-top: 1%;" v-loading="codeTableloading" :data="warehousingList" @row-click="selSotrIn">
												<template  v-if="isInOn == '1'">
													<el-table-column width="100rpx" prop="scode" label="入貨單號：" ></el-table-column>
												</template>
												<template  v-if="isInOn == '2'">
													<el-table-column width="100rpx" prop="scode" label="出货單號：" ></el-table-column>
												</template>
												<el-table-column prop="storInDate" width="220rpx" label="創建時間"></el-table-column>
											</el-table>


										</template>

										<!-- 电脑 -->
										<template v-else>
											<el-table :header-cell-style="{background:'#4B78FF',color:'#FFFFFF'}"  border style="width: 100%;margin-top: 1%;" v-loading="codeTableloading" :data="warehousingList">
												<template  v-if="isInOn == '1'">
													<el-table-column prop="scode" label="入貨單號：" ></el-table-column>
												</template>
												<template  v-if="isInOn == '2'">
													<el-table-column prop="scode" label="出货單號：" ></el-table-column>
												</template>
												<el-table-column prop="storInDate" width="200" label="創建時間"></el-table-column>
											<el-table-column prop="id" label="操作" width="100" >
												<template slot-scope="scope">
													<el-dropdown >
														<el-button size="small" type="primary" >
															<i  class="fa fa-mouse-pointer"/> 操作
														</el-button>
														<el-dropdown-menu size="small" slot="dropdown" style="padding-left: 1%">
															<el-dropdown-item  @click.native="selSotrIn(scope.row)"><i class="fa fa-search-plus"/> 详情</el-dropdown-item>
															<el-dropdown-item  @click.native="edtSotrIn(scope.row.id)"><i class="fa fa-edit"/>編輯</el-dropdown-item>
														</el-dropdown-menu>
													</el-dropdown>
												</template>
											</el-table-column>

											</el-table>
										</template>


								</div>
								<!--分页-->
								<div class="pagination">
									<el-pagination
											layout="total, prev, pager, next"
											@current-change="handleCurrentChange"
											:current-page.sync="pager.page"
											:page-size="pager.size"
											:total="pager.total">
									</el-pagination>
								</div>
							</div>
						</div>
					</div>


				</div>
			</div>

		</div>

		<!--&lt;!&ndash;編輯頁面&ndash;&gt;-->
		<el-dialog :title="dialogName" :visible.sync="dialogDiscEditVisible" width="400px">
			<el-form :model="customerForm" :rules="customerRules" ref="customerForm" label-width="130px" size="small">
				<el-row :gutter="0">
					<el-col :span="24">
						<el-form-item label="客戶編號:" prop="code">
							<el-input v-model="customerForm.code" type="text" style="width:200px"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="姓名:" prop="name">
							<el-input v-model="customerForm.name" placeholder="" auto-complete="off"
									  style="width:200px"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="電話:" prop="phone">
							<el-input v-model="customerForm.phone" placeholder="" auto-complete="off"
									  style="width:200px"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="地址:" prop="address">
							<el-input v-model="customerForm.address" placeholder="" auto-complete="off"
									  style="width:200px"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-col :span="24">
					<el-form-item  label="銷售員: "  prop="sales" >
						<el-select style="width:200px"
								   v-model="customerForm.sales"
								   filterable
								   remote
								   reserve-keyword
								   placeholder=""
								   :remote-method="remoteMethodSales"
								   :loading="tableloading">
							<el-option
									v-for="item in salesList"
									:key="item.value"
									:label="item.label"
									:value="item.value">
							</el-option>
						</el-select>
						<!--<el-input v-model="form.sales" style="width: 65%" size="medium"></el-input>-->
					</el-form-item>
				</el-col>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogDiscEditVisible = false">取消</el-button>
				<el-button type="primary" @click="customerSave" :loading="addEidtloading">確認</el-button>
			</div>
		</el-dialog>

		<!-- 庫存 -->
		<!--<el-dialog :visible.sync="tkshow">-->
			<!--<div class="ruku_list" >-->
				<!--<table cellspacing="0" cellpadding="0" class="responsive">-->
					<!--<thead>-->
                    <!--<tr>-->
                        <!--<th>订單號</th>-->
                        <!--<th>{{custName}}</th>-->
                    <!--</tr>-->
                    <!--</thead>-->
                    <!--<tr v-if="locationListB.length != 0" v-for="(item1,index) in locationListB" >-->
                        <!--&lt;!&ndash;<td class="number" v-if="index == 0">-->
                            <!--{{item1.name}}-->
                        <!--</td>&ndash;&gt;-->
                        <!--<td class="actions">-->
                            <!--{{item1.sCode}}-->
                        <!--</td>-->
                        <!--<td class="actions">-->
                            <!--({{item1.boxNo}}){{item1.item}}-->
                        <!--</td>-->

                    <!--</tr>-->
					<!--<tr  v-if="locationListB.length == 0">-->
						<!--<td colspan="4">暫無數據</td>-->
					<!--</tr>-->

				<!--</table>-->
			<!--</div>-->
		<!--</el-dialog>-->
		<el-dialog :visible.sync="tkshow">
			<div class="ruku_list">
				<table cellspacing="0" cellpadding="0" class="responsive">
					<thead>
					<tr class="trHead">
						<th>订單號</th>
						<th>單位</th>
						<th>{{custName}}</th>
						<th>入倉時間</th>
					</tr>
					</thead>
					<tr v-if="locationListB.length != 0" v-for="(item1,index) in locationListB" >
						<!--<td class="number" v-if="index == 0">
                            {{item1.name}}
                        </td>-->
						<td class="actions">
							{{item1.sCode}}
						</td>
						<td class="actions">
							{{item1.unit}}({{item1.boxNo}})
						</td>
						<td class="actions">
							{{item1.item}}
						</td>
						<td class="actions">
							{{item1.createDate*1000 | date('%Y-%m-%d %T') }}
						</td>

					</tr>
					<tr  v-if="locationListB.length == 0">
						<td colspan="4">暫無數據</td>
					</tr>

				</table>
			</div>
		</el-dialog>
	</div>
</template>

<script>
    import { getCustomerById,insertCustomer,getValidateCustomerCode,getCusInventory,getSalesList, getLocationList,updateCustomer,getLocationBycusId,getStorInItemListByCusId,getStorInList,selStorInItem,getStorInListId,getStorInListTwo,getStorOnListTwo,getStorOnItemStorinIdBy,getStorOnListId} from '../api/api'
    import ElButton from "../../node_modules/element-ui/packages/button/src/button";

    export default {
		// data() {
		// 	return{
		// 		selectid:0,
		// 	}
				
		
		// 	 },
        components: {ElButton},
		
        methods: {
            getCustomerById(){
                this.isRhdcx = false;
                this.isChdcx = false;
                this.isQhlb = false;
                this.isQbkc = true;

                this.EDIT_CUST = this.$store.getters.hasPermission("EDIT_CUST");//查詢是否能修改
                this.ind_main = false;
                this.ruku_list = true;
                this.ruku_listTwo = false;
                this.show = false;
                this.sbtnfr=true;
                this.tableloading=true;
                this.changeRed = 0;
                this.num = 0;
                this.loadingimg = false;
                this.listText = '切換地圖顯示';

                this.locationList = [];
                return getCustomerById(this.$route.params.id).then(data=>{
                    let {data:res={}}=data;
                    if(res.errcode==200){
                        var obj = res.data;
                        this.customer=obj[0];
                        this.storInItem = obj[1];
//                        this.getLocationList(obj[1]);
                        this.getLocationBycusId();
                        this.tableloading=false;
                    }else{
                        this.$message.error(res.errmsg);
                    }
                });
            },
            getLocationList(storInItem){              //載入架子頁面
                this.tableloading=true;
                var params={page:this.pager.page,size:this.pager.size};
                return getLocationList(params).then(data=>{
                    let {data:res={}}=data;
                    if(res.errcode==200){
                        var obj = res.data;
                        this.locationList=res.data;
                        this.floCount=res.data;
                        this.storList=obj[3];
                        this.tableloading=false;
                        for(var listf in this.locationList){
                            for(var m in this.locationList[listf].itemList){
                                for (var a in storInItem){
                                    if(this.locationList[listf].itemList[m].id == storInItem[a].locationId && this.locationList[listf].itemList[m].state == 1){
                                        this.locationList[listf].itemList[m].status = 1;
                                    }
                                }
                            }
                        }
                        this.loadingimg = false;
                        this.ind_main = true;
                    }else{
                        this.$message.error(res.errmsg);
                    }
                });
            },
            remoteMethodSales(query) {/*選擇銷售員*/
                if (query !== '') {
                    this.loading = true;
                    setTimeout(() => {
                        this.loading = false;
                        this.salesList = this.saList.filter(item => {
//                            console.log(item);
                            return item.label.toLowerCase()
                                    .indexOf(query.toLowerCase()) > -1;
                        });
                    }, 200);
                } else {
                    this.salesList = [];
                }
            },
            letSalesList(){/*查詢銷售員LIST*/
                return getSalesList().then(data=>{
                    let {data:res={}}=data;
                    //console.log(res)
                    if(res.errcode===200){
                        let salesOnMap= new Map();
                        res.data.forEach((item,i)=>{
                            salesOnMap.set(i,{id:item.id,value:item.name});
                        });
                        let list =[... salesOnMap.values()];
                        this.saList = list.map(item => {
                            return { value: item.value, label: item.value };
                        });
                    }
                });
            },
            cusInventory(id){           //客戶庫存
                this.tkshow = true;
                return getCusInventory(id).then(data=> {
                    let {data: res = {}} = data;
                    if (res.errcode == 200) {
                        var obj = res.data;
                        this.locationListB = obj;
                        this.custName = this.locationListB[0].name;
                    } else {
                        this.$message.error(res.errmsg);
                    }
                });
            },
            retSearch(){	//返回搜索界面
                let searchs = this.$store.getters.keywords;
                this.$router.push({
                    name: '首頁搜尋網頁面',
                    params: {
                        keywords: searchs
                    }
                })
			},
            edtSotrIn(id){	//入倉出倉編輯界面
				if(this.isInOn == '1'){		//入倉
                    this.$store.commit("setCustomerInSte", true);
                    this.$router.push({
                        name: '編輯入倉',
                        params: {
                            id: id,
                            typeId:2,
							custId:this.$route.params.id
                        }
                    })
				}else {
                    this.$store.commit("setCustomerOnSte", true);
                    this.$router.push({
                        name: '編輯出倉',
                        params: {
                            id: id,
                            typeId:2,
                            custId:this.$route.params.id
                        }
                    })
				}
            },
			serac(){
                window.history.back(-1);
			},
            getLocationBycusId(){
			    if(this.$route.params.id != undefined){
                    return getLocationBycusId(this.$route.params.id).then(data=>{
                        let {data:res={}}=data;
                        if(res.errcode==200){
                            var obj = res.data;
                            this.locationPageList=obj[0];
                            this.locationPageList.forEach((a)=>{
                                a.createDate = new Date(a.createDate*1000).Format("yyyy-MM-dd hh:mm");
                            });
                            this.floSideCount=obj[1];
                        }else{
                            this.$message.error(res.errmsg);
                        }
                    });
				}
            },
            isonIn(){
                if(this.isShow == false){
                    this.isShow = true;
				}else{
                    this.isShow = false;
				}

			},
            swcList(){    //列表切換
                this.isRhdcx = false;
                this.isChdcx = false;
                this.isQhlb = true;
                this.isQbkc = false;
				this.selectid=3;
                this.isQbkc = false;
                if(this.ruku_list == false && this.ind_main == true){
                    this.listText = '切換地圖顯示';
                    this.ruku_list = true;
                    this.ind_main = false;
                }else{
                    this.listText = '切換清單顯示';
                    if(this.locationList.length  == 0){
                        this.ind_main = false;
                        this.loadingimg = true;
                        this.getLocationList(this.storInItem);
					}else{
                        this.ind_main = true;
					}
                    this.ruku_list = false;

                }
                this.show = false;
                this.ruku_listTwo = false;
            },
            swcListTwo(){  //全部庫存
                this.ind_main = false;
				this.selectid=0;
                this.ruku_list = true;
                this.ruku_listTwo = false;
                this.show = false;
                this.sbtnfr=true;

                this.isRhdcx = false;
                this.isChdcx = false;
                this.isQhlb = false;
                this.isQbkc = true;

            },
            swcListThree(){  //入貨單查詢
				this.isQbkc = false;
                this.ind_main = false;
                this.ruku_list = false;
                this.ruku_listTwo = false;
                this.show = true;
				this.selectid=1;
                this.sbtnfr=false;
                this.getWarehousing();
                this.isInOn = '1';
                //this.selSotrIn(id);
				this.isQbkc = true;

                this.isRhdcx = true;
                this.isChdcx = false;
                this.isQhlb = false;
                this.isQbkc = false;
            },
            swcListFour(){   //出貨單查詢
                this.isQbkc = false;
                this.ind_main = false;
                this.ruku_list = false;
                this.ruku_listTwo = false;
                this.show = true;
				this.selectid=2;
                this.sbtnfr=false;
                this.getStorOnListTwo();
                this.isInOn = '2';

                this.isRhdcx = false;
                this.isChdcx = true;
                this.isQhlb = false;
                this.isQbkc = false;
            },
            listCut(index){     //切換樓層效果
                this.changeRed = index;
                this.num=index;
				
            },
            customerEdit(id){
                this.dialogName="編輯客戶資訊",
				this.dialogDiscEditVisible=true;
                this.resetForm("customerForm");
                this.customerById(id);
                this.letSalesList();
            },
            querySearch(queryString, cb) {/*載入數據*/
                var restaurants =this.customerCode;
                var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
                // 調用 callback 返回建議清單的資料
                cb(results);
            },
            createFilter(queryString) {
                return (restaurant) => {
                    return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
                };
            },
            customerById(id){
                return getCustomerById(id).then(data=>{
                    let item=data.data;
                    if(item.errcode == 200){
                        Object.assign(this.customerForm,item.data[0]);
                    }else{
                        this.$message.error(item.errmsg);
                    }
                });
            },
            handleCurrencustomerById(id){
                return getCustomerById(id).then(data=>{
                    let item=data.data;
                    if(item.errcode == 200){
                        Object.assign(this.customerForm,item.data[0]);
                    }else{
                        this.$message.error(item.errmsg);
                    }
                });
            },
            handleCurrentChange(){
                if(this.isInOn == '1'){
                    this.getWarehousing();
				}else if(this.isInOn == '2'){
                    this.getStorOnListTwo();
				}

            },
            handleSelectionChange(val){
                this.selectionItems=val;
            },
            customerSave(){
                this.$refs.customerForm.validate((valid) => {
                    if (valid) {
                        if(this.customerForm.id==""){       //新增
                            this.addEidtloading=true;
                            var  params=Object.assign({},this.customerForm);
                            insertCustomer(params).then(data=>{
                                this.addEidtloading=false;
                                let {errcode,errmsg}=data;
                                if(errcode==200){
                                    this.$message.success("新增成功！！");
                                    this.getCustomerList();
                                    this.resetForm("customerForm");
                                    this.dialogDiscEditVisible=false;
                                }else{
                                    this.$message.error(data.errmsg);
                                }
                            },err=>{
                                this.addEidtloading=false;
                            });
                        }else{                          //編輯
                            //var  params=Object.assign({},this.bankForm);
                            var  params={id:this.customerForm.id,code:this.customerForm.code,name:this.customerForm.name,phone:this.customerForm.phone,sales:this.customerForm.sales,address:this.customerForm.address};
                            updateCustomer(params).then(data=>{
                                this.addEidtloading=false;
                                let {data:res={}}=data;
                                if(res.errcode==200){
                                    this.$message.success("修改成功");
                                    this.getCustomerById();
                                    this.resetForm("customerForm");
                                    this.dialogDiscEditVisible=false;
                                }else{
                                    this.$message.error(res.errmsg);
                                }
                            },err=>{
                                this.addEidtloading=false;
                            });
                        }
                    }
                });
            },

            selSotrIn(row){/*查詢入庫的詳細資訊*/
                this.ruku_listTwo = true;
                //this.dialogVisible = true;
                this.add = true;
                this.show = false;
                this.rkCont = false;//入庫和客戶資訊
                let params={page:this.pager.page,size:this.pager.size,storInId:row.id};
                if(this.isInOn == '1'){
                    return selStorInItem(params).then(str=>{//查詢當前入庫單裡有多少資料
                        let {data:res={}}=str;
                        if(res.errcode===200){
                            let leagueMap= new Map();
                            res.data.data.forEach((item)=>{//重新處理下資料
                                let itemList= {id:item.id,boxNo:item.boxNo,state:item.state,unit:item.unit,item:item.item,qty:item.qty,locationId:item.locationId,value:item.name,
                                    itemShow:true,qtyShow:true,locationIdShow:true,boxNoShow:true};
                                if(!leagueMap.has(item.storDateId)){//添加
                                    let storIdItemList={id:item.storDateId,code:item.sCode,createDate:new Date(item.createDate * 1000).Format("yyyy/MM/dd hh:mm:ss"),addStorIn:false,storInItem:[itemList]};
                                    leagueMap.set(item.storDateId,storIdItemList)
									console.log(storIdItemList);
                                }else {
                                    leagueMap.get(item.storDateId).storInItem.push(itemList)
                                }
                            });
                            this.addWarehousingList =[... leagueMap.values()];
                        }
                    });
                }else{
                    return getStorOnItemStorinIdBy(row.id).then(data =>{
                        let {data:res={}}=data;
                        if(res.errcode===200){
                            let sotrOnMap= new Map();
                            let storDateId=null;
                            res.data.forEach((item)=> {//重新處理下資料
                                storDateId=item.storDateId;
                                let  itemList= {id:item.id,boxNo:item.boxNo,state:item.state,unit:item.unit,item:item.item,qty:item.qty,locationId:item.locationId,value:item.name,
                                    itemShow:true,qtyShow:true,locationIdShow:true,boxNoShow:true};
                                if(!sotrOnMap.has(item.storDateId)){//添加
                                    let storIdItemList={id:item.storDateId,code:item.sCode,createDate:new Date(item.createDate * 1000).Format("yyyy/MM/dd hh:mm:ss"),addStorIn:false,storInItem:[itemList]};
                                    sotrOnMap.set(item.storDateId,storIdItemList)
                                }else{
                                    sotrOnMap.get(item.storDateId).storInItem.push(itemList)
                                }
                            });
                            this.addWarehousingList =[... sotrOnMap.values()];
                        }
                    })
                }


            },
            getWarehousing(){/*查詢入庫*/
                this.codeTableloading=true;
                let params={page:this.pager.page,size:this.pager.size,cusId:this.customer.id};
                return getStorInListTwo(params).then(data=>{
                    let {data:res={}}=data;
                    if(res.errcode===200){
                        let {size,page,total,data:items=[]}=res.data;
                        this.warehousingList=items;
                        this.warehousingList.forEach((a,b)=>{
                            a.storInDate = new Date(a.storInDate*1000).Format("yyyy-MM-dd hh:mm");
                        });
                        this.pager.total=total;
                        this.pager.page=page;
                        this.pager.size=size;
                        this.codeTableloading=false;
                    }else{
                        this.$message.error(res.errmsg);
                    }
                });
            },
            getStorOnListTwo(){/*查詢出庫*/
                this.codeTableloading=true;
                let params={page:this.pager.page,size:this.pager.size,cusId:this.customer.id};
                return getStorOnListTwo(params).then(data=>{
                    let {data:res={}}=data;
                    if(res.errcode===200){
                        let {size,page,total,data:items=[]}=res.data;
                        this.warehousingList=items;
                        this.warehousingList.forEach((a,b)=>{
                            a.storInDate = new Date(a.storInDate*1000).Format("yyyy-MM-dd hh:mm");
                        });
                        this.pager.total=total;
                        this.pager.page=page;
                        this.pager.size=size;
                        this.codeTableloading=false;
                    }else{
                        this.$message.error(res.errmsg);
                    }
                });
            },
            RndNum(){//生成一個15位元數的數字
                let rnd="";
                for(let i=0;i<15;i++){
                    rnd+=Math.floor(Math.random()*10);
                }
                return rnd;
            },
            //清除表單內容
            resetForm(formName){
                if (this.$refs[formName]!==undefined) {
                    this.$refs[formName].resetFields();
                }
            }
        },
        data() {
            //驗證客戶編號是否重複
            var validateCustomerCode=(rule, value, callback) => {
                var params={code:this.customerForm.code};
                return getValidateCustomerCode(params).then(data=>{
                    if(this.customerForm.id == '') {
                        let item = data.data.data;
                        if (item) {
                            callback(new Error('客戶編號重複！'));
                        } else {
                            callback();
                        }
                    }
                    callback();
                });
                callback();
            };
            return {
                //查詢準則
                isQbkc:true,
                isRhdcx:false,
                isChdcx:false,
                isQhlb:false,
				listText:'切換地圖顯示',
                codeTableloading:false,
                loadingimg:true,
                loading:true,
                salesList:[],//銷售員LIST
                saList:[],//銷售員LIST
                isShow:true,
                tkshow:false,
                custName:'',
                EDIT_CUST:false,//是否可以修改
                searchBankName:"",
                customer:[],
                warehousingList:[],
                ruku_list:true,
                ind_main:false,
                ruku_listTwo:false,
                locationListB:[],
                show:false,
                sbtnfr:true,
                isInOn:'',  //判斷是入貨單查詢還是出貨單查詢
                storInItem:[],
                selectionItems:[],
                num:0,
				selectid:0,//選擇btnid
                changeRed:0,
                storList:[],
                locationList:[],
                locationPageList:[],
                floCount:[],
                floSideCount:[],
                addWarehousingList:[
                    {createDate:null,code:this.RndNum(),addStorIn:true,storInItem:[{boxNo:'',item:'',qty:null,locationId:'',value:'',itemShow:true,qtyShow:true,locationIdShow:true}]},
                ],
                tableloading:false,
                addEidtloading:false,
                dialogDiscEditVisible:false,
                pager:{
                    page:0,
                    size:10,
                    total:0
                },
                dialogName:'',
                customerForm:{
                    id:"",
                    sales:"",
                    code:"",
                    name:"",
                    phone:"",
                    address:''
                },
                form:{
                    id:null,
                    sCode:null,
                    code:null,
                    name:null,
                    phone:null,
                    address:null,
                    sales:null,
                    createDate:null,
                    sCodeShow:false,
                    codeShow:false,
                    createDateShow:true
                },
                //新增客戶資訊表單驗證
                customerRules: {
                    code: [
                        {required: true, message: '請輸入客戶編號', trigger: 'blur' },
                        { min: 1, max: 18, message: '超過指定長度', trigger: 'blur' },
                        { validator: validateCustomerCode,trigger: 'blur' }
                    ],
                    name:[
                        {required: true, message: '請輸入客戶名', trigger: 'blur' },
                        { min: 1, max: 15, message: '超過指定長度', trigger: 'blur' }
                    ],
                    phone:[
                        {required: true, message: '請輸入手機號', trigger: 'blur' },
                        { min: 1, max: 13, message: '超過指定長度', trigger: 'blur' }
                    ],
                    address:[
                        {required: true, message: '請輸入位址', trigger: 'blur' },
                        { min: 1, max: 100, message: '長度最大為100', trigger: 'blur' }
                    ],
                    sales:[
                        {required: true, message: '請輸入銷售員', trigger: 'blur' }
                    ]
                }
            }
        },

//        mounted() {
//
//        },
        computed: {
            canAdd(){
                return this.$store.getters.hasPermission("BANK_ADD");
            },
            canEdit(){
                return this.$store.getters.hasPermission("BANK_EDIT");
            },
            canDel(){
                return this.$store.getters.hasPermission("BANK_DEL");
            }

        },
        activated(){
            Date.prototype.Format = function (fmt) {
                var o = {
                    "M+": this.getMonth() + 1, //月份
                    "d+": this.getDate(), //日
                    "h+": this.getHours(), //小時
                    "m+": this.getMinutes(), //分
                    "s+": this.getSeconds(), //秒
                    "q+": Math.floor((this.getMonth() + 3) / 3), //季度
                    "S": this.getMilliseconds() //毫秒
                };
                if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
                for (var k in o)
                    if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
                return fmt;
            };
            this.getCustomerById();
        },

    }

</script>

<style lang="scss" scoped>
	.menu{
		.right{
			float: right;
		}
	}
	.el-tag + .el-tag {
		margin-left: 5px;
	}
	.abc {
		background: red;
	}
	.trHead
	{
		background-color: #4B78FF;
		color: white;
	}
	#btnlist {
	    height: 40px;
	    // border-top: #060 2px solid;
	    // border-bottom: #060 2px solid;
	    background-color: #F2F2F2;
		color: #999999;
		margin-top: 10px;
	}
	 
	#btnlist ul {
	    list-style: none;
	  
	}
	 
	#btnlist li {
	    display: inline;
	    line-height: 40px;
	    float:left;
		margin-left: 12px;
		
	}
	.selectbtn
	{
		color: #333333;
		font-weight: bold;
		border-bottom: 3px #2774F4 solid;
	}
	 
	 .noselectbtn
	 {
		 color: #999999;
		 font-weight: normal;
	 	border-bottom: 0px;
	 }
	

	.xinz button{background:#4B78FF;border:none;margin-bottom:1rem;}
	.xinz button:hover{background:#4B78FF;color:#fff;}

	ul,li{padding-left:0px;margin: 0px;}

	.background{
		background: #4B78FF;
	}
	.fanhui{padding:8px 18px;border:none;border-radius: 5px;background: #4B78FF; color:#fff;}
	.fanhui:hover{background:#4B78FF; cursor: pointer;}
	// .ruku_list {
	// 	margin-top: 5%;
		
	// }
	.qbkc{
	    color: #fff;
	    background-color: #4B78FF;
	    border-color: #4B78FF;
	}

	// .qbkc{color: #fff;background-color: #4B78FF;border-color: #4B78FF;}
</style>




// WEBPACK FOOTER //
// src/views/Search.vue